import Chart from 'chart.js/auto';
const chartjs = require('../../../../../../components/chart/chartjs');

export function createTreemapChart(a) {
    const chartContainer = document.querySelector('.card-chart');
    if (!chartContainer) return;

    chartContainer.innerHTML = '<canvas class="chartjs" id="itemTreemapChart"></canvas>';
    const canvas = document.getElementById('itemTreemapChart');

    const existingChart = Chart.getChart(canvas);
    if (existingChart) {
        existingChart.destroy();
    }

    const data = [
        { name: 'Avocado / boxes', value: 15 },
        { name: 'Banana', value: 6 },
        { name: 'Carrot', value: 6 },
        { name: 'Cilantro', value: 5 },
        { name: 'Aloe', value: 4 },
        { name: 'Apio', value: 3 },
        { name: 'Batata', value: 2 },
        { name: 'Yuca', value: 2 }
    ];

    chartjs.start({
        elem: 'treemap',
        act: 'createSimple',
        targetChart: { html: canvas },
        data: data,
        options: {
            responsive: true,
            aspectRatio: false,
            aspectRatio: 10 / 10,
            
        }
    });
}